<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="leafletsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Ulotki</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchLeaflets"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['leaflet'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip v-if="user.permissions['leaflet'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.ulotka',params:{}}" fab dark small><v-icon>mdi-plus</v-icon></v-btn>
                  </template>
                    <span>Dodaj rekord</span>
                </v-tooltip>

              </v-toolbar>
            </template>
            <template v-slot:item.file_name="{ item }">
              <span>{{item.file_name+'.'+item.file_type}}</span>
            </template>
            <template v-slot:item.actions="{ item }">

                <v-tooltip v-if="item.status && user.permissions['leaflet'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.ulotka',params:{id:item.id}}" icon><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['leaflet'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="deleteItem(item)" icon><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['leaflet'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="reactivateItem(item)" icon><v-icon>mdi-delete-restore</v-icon></v-btn>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['leaflet'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="forceDeleteItem(item)" icon><v-icon color="error">mdi-delete-forever</v-icon></v-btn>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template>

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && leafletsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadLeaflets" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadLeaflets" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'

  export default {
    props:{
      reload: Boolean
    },
    components:{
      confirm,
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      search:'',
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,visible:true},
        { text: 'Nazwa ulotki', value: 'name',filterable:true,filterColumn:"name",visible:true},
        { text: 'Opis', value: 'description',filterable:true,filterColumn:"description",visible:true},
        { text: 'Plik', value: 'file_name',filterable:false,filterColumn:"file_name",visible:true},
        { text: 'Status', value: 'status',filterable:false,filterColumn:"status",visible:true},
        { text: '', value: 'actions', sortable: false,filterable:false,visible:true},
      ],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        val || this.close()
      },
      leafletEditStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      leafletAddStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      leafletDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getLeafletOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setLeafletOptions', {options:value} )
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getLeafletOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getLeafletEdit;
      },
      tableItems(){
        return this.$store.getters.getLeaflets;
      },
      leafletsLoadStatus(){
        return this.$store.getters.getLeafletsLoadStatus;
      },
      leafletEditLoadStatus(){
        return this.$store.getters.getLeafletEditLoadStatus
      },
      leafletEditStatus(){
        return this.$store.getters.getLeafletEditStatus();
      },
      leafletAddStatus(){
        return this.$store.getters.getLeafletAddStatus();
      },
      leafletDeleteStatus(){
        return this.$store.getters.getLeafletDeleteStatus();
      },
      computedHeaders () {
        var h = _.filter(this.headers,function(o) { return o.visible; })

        // if(!this.showDeleted && this.user.permissions['leaflet'] <= 5) return h.filter(h => h.value!=='status' && h.value!=='actions')
        // else if(this.showDeleted && this.user.permissions['leaflet'] <= 5) return h.filter(h => h.value!=='actions')
        // else 
        if(!this.showDeleted) return h.filter(h => h.value!=='status')
        else return h
      },
    },
    mounted(){
      if(this.reload)this.loadLeaflets();
    },
    methods: {
      loadLeaflets(){
        this.search='';
        this.$store.dispatch( 'loadLeaflets' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreLeaflets' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editLeafletReactivate',{slug:item.id});
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć ulotkę?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteLeaflet', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać ulotkę na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteLeaflet', {slug:  item.id});
            }
        })
      },
      searchLeaflets(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchLeaflets',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
</style>